export const ItemTypeNames = {
  closedPeer: 'closedPeer',
  discussionPrompt: 'discussionPrompt',
  gradedDiscussionPrompt: 'gradedDiscussionPrompt',
  exam: 'exam',
  gradedLti: 'gradedLti',
  gradedPeer: 'gradedPeer',
  gradedProgramming: 'gradedProgramming',
  lecture: 'lecture',
  notebook: 'notebook',
  lock: 'lock',
  peer: 'peer',
  phasedPeer: 'phasedPeer',
  programming: 'programming',
  quiz: 'quiz',
  review: 'review',
  splitPeerReviewItem: 'splitPeerReviewItem',
  staffGraded: 'staffGraded',
  ungradedAssignment: 'ungradedAssignment',
  supplement: 'supplement',
  teammateReview: 'teammateReview',
  ungradedLti: 'ungradedLti',
  ungradedWidget: 'ungradedWidget',
  ungradedProgramming: 'ungradedProgramming',
  workspaceLauncher: 'workspaceLauncher',
  ungradedLab: 'ungradedLab',
  // currently pseudo-items for the learning experience
  singleQuestionSubmit: 'singleQuestionSubmit',
  assessOpenSinglePage: 'assessOpenSinglePage',
  lessonChoice: 'lessonChoice',
  assignmentGroup: 'assignmentGroup',
  wiseFlow: 'wiseFlow',
  gradedPlaceholder: 'gradedPlaceholder',
  ungradedPlaceholder: 'ungradedPlaceholder',
  placeholder: 'placeholder',
} as const;

export const ItemTypeLabels = {
  VIDEO: 'VIDEO',
  GRADED_QUIZ: 'GRADED_QUIZ',
  PRACTICE_QUIZ: 'PRACTICE_QUIZ',
  READING: 'READING',
  DISCUSSION_PROMPT: 'DISCUSSION_PROMPT',
  GRADED_DISCUSSION_PROMPT: 'GRADED_DISCUSSION_PROMPT',
  GRADED_PROGRAMMING_ASSIGNMENT: 'GRADED_PROGRAMMING_ASSIGNMENT',
  PRACTICE_PROGRAMMING_ASSIGNMENT: 'PRACTICE_PROGRAMMING_ASSIGNMENT',
  GRADED_PEER_REVIEW: 'GRADED_PEER_REVIEW',
  PRACTICE_PEER_REVIEW: 'PRACTICE_PEER_REVIEW',
  APP_ITEM: 'APP_ITEM',
  GRADED_LTI_ITEM: 'GRADED_LTI_ITEM',
  PRACTICE_LTI_ITEM: 'PRACTICE_LTI_ITEM',
  GRADED_INDIVIDUAL_ASSIGNMENT: 'GRADED_INDIVIDUAL_ASSIGNMENT',
  PRACTICE_INDIVIDUAL_ASSIGNMENT: 'PRACTICE_INDIVIDUAL_ASSIGNMENT',
  GRADED_TEAM_ASSIGNMENT: 'GRADED_TEAM_ASSIGNMENT',
  PRACTICE_TEAM_ASSIGNMENT: 'PRACTICE_TEAM_ASSIGNMENT',
  TEAMMATE_REVIEW: 'TEAMMATE_REVIEW',
  UNGRADED_LAB: 'UNGRADED_LAB',
  GRADED_PLUGIN: 'GRADED_PLUGIN',
  UNGRADED_PLUGIN: 'UNGRADED_PLUGIN',
  WISE_FLOW: 'WISE_FLOW',
  WORKSPACE_LAUNCHER: 'WORKSPACE_LAUNCHER',
  UNKNOWN: 'UNKNOWN',
} as const;

export type ItemTypeName = (typeof ItemTypeNames)[keyof typeof ItemTypeNames];
export type ItemTypeLabel = (typeof ItemTypeLabels)[keyof typeof ItemTypeLabels];

export type ItemType = ItemTypeName;
